import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-card-item-details"
}
const _hoisted_2 = { class: "font-size-12-600" }
const _hoisted_3 = { class: "font-size-10-400 mt-2" }
const _hoisted_4 = { class: "font-size-10-400 mt-2 font-grey-dark" }
const _hoisted_5 = { class: "font-size-10-400 mt-2 font-grey-dark" }
const _hoisted_6 = { class: "font-black" }
const _hoisted_7 = { class: "text-right font-size-16-600" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3 full-width"
}
const _hoisted_9 = { class: "d-flex ga-2" }
const _hoisted_10 = { class: "two-line-ellipsis font font-grey-dark" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "text-right" }

import {ref, computed} from 'vue';
import Icon from "@/components/Icons/Icon.vue";
import OrderDetailsDialog from "@/views/OrdersComponents/OrderDetails/ProductDetails/OrderDetailsDialog.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetails',
  props: {
  item: {
    type: Object,
    required: true
  },
  paymentStatus: {
    type: Object,
    default: () => ({color: '', status: ''})
  },
  isShipping: {
    type: Boolean,
    default: false
  },
  supplierId: {
    type: String,
  }
},
  setup(__props) {

const props = __props;

const showMore = ref(false);

const toggleText = () => {
  showMore.value = !showMore.value;
};

const getTitle = computed(() => {
  if (props.item?.product) {
    return props.item.product.name;
  }

  return props.item.name;
})

const getImage = computed(() => {
  if (props.item?.product && props.item?.product?.images[0]) {
    return props.item?.product?.images[0].full;
  }

  return null;
})

const getIcon = computed(() => {
  const type = props.item.type;

  if (type === 'clinic_product' || type === 'supplement' || type === 'product') {
    return 'product-icon';
  }

  return null;
})

const getPrice = computed(() => {
  return props.item.price_display ?? '-';
})

const getBrandName = computed(() => {
  if (props.item?.product && props.item?.product?.brand) {
    return `(${props.item?.product?.brand?.name})`;
  }

  return '';
})

const getSku = computed(() => {
  if (props.item?.product) {
    return props.item.product.sku;
  }

  return '';
})

const getQuantity = computed(() => {
  return `${props.item.quantity} item`;
})

const getProductDescription = computed(() => {
  return props.item?.product?.attributes.length > 0
});

const getAttributes = computed(() => {
  const itemAttributes = props.item?.attributes;
  
  if (itemAttributes?.length > 0) {
    return [
      ...itemAttributes,
      {
        name: 'description',
        value: props.item.product_description,
      }
    ];
  }

  const productAttributes = props.item?.product?.attributes ?? [];
  return [
    ...productAttributes,
    {
      name: 'description',
      value: props.item?.product?.description,
    }
  ];
})

const getAttributeValue = (name) => {
  if (props.item?.product && props.item.type !== 'clinic_service') {
    return getAttributes.value.find((attribute) => attribute.name == name)?.value;
  }

  return ''
};

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (!__props.isShipping)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (getImage.value)
          ? (_openBlock(), _createBlock(_component_v_sheet, {
              key: 0,
              class: "logo-container m-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                  class: "logo-container__image"
                }, null, 4)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 1,
              class: _normalizeClass([{'secondary-background-button-color': __props.supplierId === 'clinic'}, "icon-container"])
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, { icon: getIcon.value }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["class"])),
        _createVNode(_component_v_card_text, { class: "card-description" }, {
          default: _withCtx(() => [
            _createElementVNode("section", null, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(getTitle.value), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(getBrandName.value), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(getSku.value), 1),
              _createElementVNode("p", _hoisted_5, [
                _cache[1] || (_cache[1] = _createTextVNode(" Qty: ", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(getQuantity.value), 1)
              ])
            ]),
            _createElementVNode("section", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(getPrice.value), 1),
              _createElementVNode("p", {
                class: _normalizeClass([__props.paymentStatus.color, "font-size-12-600"])
              }, _toDisplayString(__props.paymentStatus.status), 3)
            ]),
            (getProductDescription.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createVNode(Icon, { icon: "message-icon" })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        innerHTML: getAttributeValue('comments')
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_v_btn, {
                      ripple: false,
                      class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
                      variant: "plain",
                      onClick: toggleText
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Show More ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(OrderDetailsDialog, {
                    modelValue: showMore.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showMore).value = $event)),
                    attributes: getAttributes.value
                  }, null, 8, ["modelValue", "attributes"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})